module.exports = __webpack_public_path__ + "img/jordan.bfa29270.jpg";